import { FormControl, Validators } from '@angular/forms';

export const setControlRequired = (
  controls: FormControl[],
  isRequired: boolean,
) => {
  controls.forEach((control) => {
    isRequired
      ? control.addValidators(Validators.required)
      : control.removeValidators(Validators.required);

    control.updateValueAndValidity();
  });
};
